<template>
  <div class="order-list-item" @click='gotoDetails'>
    <span class='order-status' v-bind:class="{ 
      ordered: order.order_status == '受注',
      quote: order.order_status == '見積り'
        }">{{ order.order_status }}</span>
    <Icon icon='chevron-right'/>
    <time class='time'>{{ order.preferred_at }}</time>
    <span class='id'>{{ order.order_id }}</span>
    <span class='order-name'>{{ order.order_name }}</span>
    <span v-if='order.client' class='client-name'>{{ order.client.name }}</span>
    <span v-if='order.client' class='post-code'>{{ order.client.post_code }}</span>
    <address v-if='order.client' class='address'>{{ order.client.address }}</address>
  </div>
</template>

<script>
export default {
  props: ['order'],
  methods: {
    gotoDetails: function() {
      this.$router.push('/orders/'+this.order.order_id);
    }
  }
}
</script>

<style lang='scss'>
.order-list-item {
  padding: 8px;
  font-size: 16px;
  line-height: 1.5;
  cursor: pointer;
  > * {
    display: block;
  }
  > .icon {
    float: left;
    font-size: 1.25em;
    margin-right: .25em;
    path {
      fill: #3366ff;
    }
  }
  .id {
    display: inline;
  }
  .icon-chevron-right {
    float: right;
    opacity: .5;
    font-size: 1.25em;
  }
  .time {
    float: right;
    opacity: .5;
  }
  .order-status {
    padding: 3px;
    width: 100%;
    font-size: 0.8em;
    color: white;
    font-weight: bold;
  }
  .ordered {
    background-color: #3894FF;
  }
  .quote {
    background-color: #fd7e14;
  }
  .order-name {
    float: left;
    margin-right: 1em;
  }
  .client-name {
    margin-bottom: .5em;
  }
  .post-code {
    opacity: .5;
  }
  .address {
    font-style: normal;
    opacity: .5;
  }
}
</style>